import React, { Context } from 'react'
import { TableContextValue } from './table-context'

const RendererContext: Context<{
  tableContext: TableContextValue
  root?: {
    id: string
    height: number
  }
  showBorders: boolean
  width: number
}> = React.createContext(null)

export default RendererContext
